module.exports = __webpack_public_path__ + "img/1465643583.bc9b719b.jpg";